// extracted by mini-css-extract-plugin
export default {"main":"Privacy_main__V0qb1","main_back":"Privacy_main_back__5LiRz","text":"Privacy_text__4fgaZ"};